import React, { useState } from "react";
import styles from "./RPGGameCharacterTraining.module.scss";
import WrapperWithFrame from "../../../layout/WrapperWithFrame/WrapperWithFrame";
import RPGGameCharacterTrainingRedistribution from "./RPGGameCharacterTrainingRedistribution/RPGGameCharacterTrainingRedistribution";
import RPGGameCharacterTrainingDevelopment from "./RPGGameCharacterTrainingDevelopment/RPGGameCharacterTrainingDevelopment";
import RPGGameCharacterTrainingCybernetics from "./RPGGameCharacterTrainingCybernetics/RPGGameCharacterTrainingCybernetics";
import { ETrainingTabs } from "../../../../constants/rpgGame/ETrainingTabs";
import TransitionProvider, {
  TransitionStyleTypes,
} from "../../../../providers/TransitionProvider";
import { useAppSelector } from "../../../../hooks/redux";
import RPGGameCharacterTrainingInfo from "./RPGGameCharacterTrainingInfo/RPGGameCharacterTrainingInfo";
import HeaderBtn from "../../../layout/HeaderBtn/HeaderBtn";
interface Props {
  activeTab: ETrainingTabs;
}

const trainingTabs = [
  {
    id: ETrainingTabs.DEVELOPMENT,
    title: "Очки развития: 10000",
    content: <RPGGameCharacterTrainingDevelopment />,
    info: [
      {
        title: "Механика Прокачки Персонажа",
        text: "В Dystopia RPG прогресс зависит не от времени, а от действий игрока. Каждое решение, каждый бой — это шаг вперёд в эволюции бойца. Система прокачки строится вокруг трёх ключевых направлений: характеристики, параметры и приёмы",
      },
      {
        title: "Очки Прокачки — Только за PvP",
        text: "Игрок зарабатывает очки прокачки исключительно за победы в PvP-сражениях. Это делает прогресс по-настоящему заслуженным и соревновательным. PvE-бои полезны для тренировки, но не дают очков прокачки.",
      },
      {
        title: "Характеристики",
        text: "Каждая прокачка характеристики требует фиксированное количество очков, которое растёт с каждым последующим улучшением:\nПервая прокачка — базовая стоимость.\nКаждая следующая — дороже предыдущей (пример: 100 → 200 → 300 и т.д.).\nИгрок сам распределяет нераспределённые очки, нажимая на «+» рядом с нужной характеристикой (например: ловкость, меткость, инициатива, выносливость и др.).",
      },
      {
        title: "Параметры",
        text: "Параметры (внутренние боевые функции, влияющие на эффективность) работают аналогично характеристикам, но требуют меньшего количества очков на старте. Однако, как и в случае с характеристиками, стоимость каждой следующей прокачки возрастает (например: 50 → 75 → 100 и т.д.).",
      },
      {
        title: "Приёмы",
        text: "Каждый боевой приём развивается в процессе использования:\nИспользование приёма в бою добавляет прогресс к его прокачке (например: +5% за использование).\nЧтобы улучшить приём, нужно многократно применять его в боях.\nЭто стимулирует игрока не только побеждать, но и экспериментировать с тактиками.",
      },
      {
        title: "Дополнительно: Тренировочная Комната",
        text: "В специальном разделе игры игроки могут:\nПерераспределять уже вложенные очки между характеристиками, параметрами и кибернетикой.\nПовышать уровень кибернетических имплантов и их функциональность.\nОтслеживать прогресс и планировать развитие бойца с учётом боевого стиля.",
      },
      {
        title: "",
        text: "Итог: система прокачки поощряет активную игру, разнообразие тактик и индивидуальное развитие бойца. Каждый апгрейд ощущается как заслуженное достижение, а не механическое накопление опыта",
      },
    ],
  },
  {
    id: ETrainingTabs.CYBERNETICS,
    title: "Очки кибернетики: 10000",
    content: <RPGGameCharacterTrainingCybernetics />,
    info: [
      {
        title: "Механика Прокачки Персонажа",
        text: "В Dystopia RPG прогресс зависит не от времени, а от действий игрока. Каждое решение, каждый бой — это шаг вперёд в эволюции бойца. Система прокачки строится вокруг трёх ключевых направлений: характеристики, параметры и приёмы",
      },
      {
        title: "Очки Прокачки — Только за PvP",
        text: "Игрок зарабатывает очки прокачки исключительно за победы в PvP-сражениях. Это делает прогресс по-настоящему заслуженным и соревновательным. PvE-бои полезны для тренировки, но не дают очков прокачки.",
      },
      {
        title: "Характеристики",
        text: "Каждая прокачка характеристики требует фиксированное количество очков, которое растёт с каждым последующим улучшением:\nПервая прокачка — базовая стоимость.\nКаждая следующая — дороже предыдущей (пример: 100 → 200 → 300 и т.д.).\nИгрок сам распределяет нераспределённые очки, нажимая на «+» рядом с нужной характеристикой (например: ловкость, меткость, инициатива, выносливость и др.).",
      },
      {
        title: "Параметры",
        text: "Параметры (внутренние боевые функции, влияющие на эффективность) работают аналогично характеристикам, но требуют меньшего количества очков на старте. Однако, как и в случае с характеристиками, стоимость каждой следующей прокачки возрастает (например: 50 → 75 → 100 и т.д.).",
      },
      {
        title: "Приёмы",
        text: "Каждый боевой приём развивается в процессе использования:\nИспользование приёма в бою добавляет прогресс к его прокачке (например: +5% за использование).\nЧтобы улучшить приём, нужно многократно применять его в боях.\nЭто стимулирует игрока не только побеждать, но и экспериментировать с тактиками.",
      },
      {
        title: "Дополнительно: Тренировочная Комната",
        text: "В специальном разделе игры игроки могут:\nПерераспределять уже вложенные очки между характеристиками, параметрами и кибернетикой.\nПовышать уровень кибернетических имплантов и их функциональность.\nОтслеживать прогресс и планировать развитие бойца с учётом боевого стиля.",
      },
      {
        title: "",
        text: "Итог: система прокачки поощряет активную игру, разнообразие тактик и индивидуальное развитие бойца. Каждый апгрейд ощущается как заслуженное достижение, а не механическое накопление опыта",
      },
    ],
  },
  {
    id: ETrainingTabs.REDISTRIBUTION,
    title: "Перераспределение",
    content: <RPGGameCharacterTrainingRedistribution />,
    info: [
      {
        title: "Механика Прокачки Персонажа",
        text: "В Dystopia RPG прогресс зависит не от времени, а от действий игрока. Каждое решение, каждый бой — это шаг вперёд в эволюции бойца. Система прокачки строится вокруг трёх ключевых направлений: характеристики, параметры и приёмы",
      },
      {
        title: "Очки Прокачки — Только за PvP",
        text: "Игрок зарабатывает очки прокачки исключительно за победы в PvP-сражениях. Это делает прогресс по-настоящему заслуженным и соревновательным. PvE-бои полезны для тренировки, но не дают очков прокачки.",
      },
      {
        title: "Характеристики",
        text: "Каждая прокачка характеристики требует фиксированное количество очков, которое растёт с каждым последующим улучшением:\nПервая прокачка — базовая стоимость.\nКаждая следующая — дороже предыдущей (пример: 100 → 200 → 300 и т.д.).\nИгрок сам распределяет нераспределённые очки, нажимая на «+» рядом с нужной характеристикой (например: ловкость, меткость, инициатива, выносливость и др.).",
      },
      {
        title: "Параметры",
        text: "Параметры (внутренние боевые функции, влияющие на эффективность) работают аналогично характеристикам, но требуют меньшего количества очков на старте. Однако, как и в случае с характеристиками, стоимость каждой следующей прокачки возрастает (например: 50 → 75 → 100 и т.д.).",
      },
      {
        title: "Приёмы",
        text: "Каждый боевой приём развивается в процессе использования:\nИспользование приёма в бою добавляет прогресс к его прокачке (например: +5% за использование).\nЧтобы улучшить приём, нужно многократно применять его в боях.\nЭто стимулирует игрока не только побеждать, но и экспериментировать с тактиками.",
      },
      {
        title: "Дополнительно: Тренировочная Комната",
        text: "В специальном разделе игры игроки могут:\nПерераспределять уже вложенные очки между характеристиками, параметрами и кибернетикой.\nПовышать уровень кибернетических имплантов и их функциональность.\nОтслеживать прогресс и планировать развитие бойца с учётом боевого стиля.",
      },
      {
        title: "",
        text: "Итог: система прокачки поощряет активную игру, разнообразие тактик и индивидуальное развитие бойца. Каждый апгрейд ощущается как заслуженное достижение, а не механическое накопление опыта",
      },
    ],
  },
];

const RPGGameCharacterTraining: React.FC<Props> = ({ activeTab }) => {
  const activeTabDetails =
    trainingTabs.find((tab) => tab.id === activeTab) || trainingTabs[0];
  const gameInited = useAppSelector((state) => state.ui.gameInited);

  const [isInfoOpen, setIsInfoOpen] = useState(false);

  return (
    <WrapperWithFrame className={styles.rpgGameCharacterTraining} size="lg">
      <div className={styles.rpgGameCharacterTraining__main}>
        <TransitionProvider
          className={styles.rpgGameCharacterTraining__header}
          inProp={gameInited}
          style={TransitionStyleTypes.top}
          height={86}
        >
          <h5 className={styles.rpgGameCharacterTraining__headerTitle}>
            {isInfoOpen
              ? activeTabDetails.info[0].title
              : activeTabDetails.title}
          </h5>
          <HeaderBtn
            onClick={() => setIsInfoOpen((prev) => !prev)}
            type={isInfoOpen ? "close" : "info"}
          />
        </TransitionProvider>
        {isInfoOpen && activeTabDetails.info ? (
          <RPGGameCharacterTrainingInfo data={activeTabDetails.info} />
        ) : (
          activeTabDetails.content
        )}
      </div>
    </WrapperWithFrame>
  );
};

export default RPGGameCharacterTraining;
